import { Outlet } from "react-router-dom";
import SlideBar from "../../Components/SlideMenu";
import ChatBox from "../../Components/Chatbox/Chatbox";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import PrivateRoute from "../../Components/Routes/Components/PrivateRoute"
import NewSlideBar from "../../Components/NewSlideMenu";



function DashboardLayout () { 
  return(
    <>
      {/*<div id="main-wrapper" >*/}
      <PrivateRoute>
        <div>
        <Header />
        <ChatBox />
        {/* <SlideBar /> */}
        <NewSlideBar />
        <Outlet />
        
        <Footer />
        </div>
      </PrivateRoute>
    
    </>
  )
}

export default DashboardLayout;  